<template>
  <div class="overlay">
    <div class="bg-white modal rounded">
      <div>
        <p class="font-medium text-xl">Verify Your Account</p>
        <p>Account Verification link has been sent to the email address you provided</p>
      </div>
      <div>
        <svg
          class="mx-auto bounce"
          width="60"
          height="60"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.01 17.6507L29.9998 29.6456L53.99 17.6505C53.809 14.4995 51.1964 12 48 12H12C8.80355 12 6.1909 14.4995 6.01 17.6507Z"
            fill="#111827"
          />
          <path
            d="M54 24.3537L29.9998 36.3538L6 24.3539V42C6 45.3137 8.68629 48 12 48H48C51.3137 48 54 45.3137 54 42V24.3537Z"
            fill="#111827"
          />
        </svg>
      </div>
    </div>
  </div>
</template>
